<template>
  <header>
    <b-navbar toggleable="lg" type="dark" class="custom-navbar">
      <router-link :to="'/'+locale" class="navbar-brand">
        <img :src="logo" alt="logo" width="100%" />
      </router-link>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <li v-for="item in menuItems" :key="item.id">
            <span class="p-2 mr-3" @click="navClick(item.link)">{{item.name}}</span>
          </li>
          <li>
            <a class="btn btn-zum-editor" :href="'https://' + editorUrl + '/new/' + (getProductDetail() !== null ? '?productType='+ getProductDetail() : '')">
              <font-awesome-icon icon="edit" class="mr-1" />{{$t("header.zum_editor")}}
            </a>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-button
      v-if="Math.floor(Date.now() / 1000) < 1764543600"
      :href="'https://' + editorUrl + '/new/' + (getProductDetail() !== null ? '?productType='+ getProductDetail() : '')"
      squared
      class="px-2 py-2 mb-0"
      style="width: 100%;text-align: center;-webkit-font-smoothing: antialiased;color: #fff;background: #D32F2F;">
      <CountDown />
    </b-button>
    <b-button
        v-else-if="appName !== 'nightsky' && appName !== 'nightskyuk'"
        :href="'https://' + editorUrl + '/new/' + (getProductDetail() !== null ? '?productType='+ getProductDetail() : '')"
        squared
        class="px-2 py-2 mb-0"
        style="width: 100%;text-align: center;-webkit-font-smoothing: antialiased;color: #fff;background: #78909C;">
      <CountDown />
    </b-button>
  </header>
</template>

<script>
import { BNavbar, BNavbarToggle, BCollapse, BNavbarNav, BButton } from "bootstrap-vue";
import i18n from '../i18n';
import CountDown from './CountDown.vue'

export default {
  name: "Header",
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME,
      locale: i18n.locale,
      logo: require('../assets/images/logo-light-' + process.env.VUE_APP_APP_NAME + '.png'),
      editorUrl: 'editor.' + process.env.VUE_APP_ROOT_DOMAIN,
      menuItems: [
        { id: 1, link: "home", name: this.$t("header.home") },
        { id: 2, link: "our-works", name: this.$t("header.how_it_works") },
        { id: 3, link: "inspiration", name: this.$t("header.inspiration") },
      ],
    };
  },
  components: {
    BNavbar,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BButton,
    CountDown,
  },
  methods: {
    getProductDetail: function() {
      return this.$route.query.productDetail
    },
    navClick: function (hash) {
      let element = document.getElementById(hash);
      this.$router.push('/' + this.locale + `/#${hash}`);
      if (!element) return;
      if (hash) {
        window.scroll({
          top: window.scrollY + element.getBoundingClientRect().top,
          behavior: "smooth",
        });
      } else {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>